import React, { useState, useEffect } from 'react'
import messages from "./messages";
import {FormattedMessage} from "react-intl";
import { Full as Loading } from 'components/Loading'

const CustomerSettingsPage = () => {
  const [details, setDetails] = useState(null)

  useEffect(() => {
    fetch(`/rest/v2/customer`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => setDetails(data[0]))
      .catch((err) => window.alert(err))
  }, [])

  if (!details) {
    return (
      <Loading />
    )
  }

  return (
    <main className="flex-1 overflow-y-auto focus:outline-none" tabIndex="0">
      <div className="relative max-w-4xl mx-auto md:px-8 xl:px-0">
        <div className="pt-10 pb-16">
          <div className="px-4 sm:px-6 md:px-0 py-6">
            <div className="mt-10 divide-y divide-gray-200">
              <div className="space-y-1">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  <FormattedMessage {...messages.title} />
                </h3>
                <p className="max-w-2xl text-sm text-gray-500">
                  <FormattedMessage {...messages.description} />
                </p>
              </div>

              <div className="mt-6">
                <dl className="divide-y divide-gray-200">
                  {Object.entries({
                    name: details.name,
                    phone: details.telephone,
                    address: details.address,
                    zip: details.zip,
                    city: details.city,
                    country: details.country.name,
                    vat: details.euvatid,
                    ean: details.ean,
                  }).map(([key, value]) => (
                    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
                      <dt className="text-sm font-medium text-gray-500">
                        <FormattedMessage {...messages[key] } />
                      </dt>
                      <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <span className="grow">
                          { value }
                        </span>
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default CustomerSettingsPage
